import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { FixLater } from "types";

dayjs.extend(utc);

/**
 * Normalises a reviewed calibration date to an ISO string.
 *
 * The AI extraction returns ISO date strings, but once a user corrects a field the
 * date picker hands back a moment instead. Both have to reach the API in the same
 * shape or the stored calibration date silently shifts.
 */
export const toISODate = (value: FixLater): string | undefined => (value ? dayjs.utc(value).toISOString() : undefined);
